import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'Cubic.easeIn', index, istemplate }) {
  var finalAlpha = sprite.alpha;
  sprite.alpha = 0;
  var x = sprite.x;
  sprite.x = sprite.x + 30;
  let delay = 0;
  if (istemplate && index) {
    delay = index * (duration * speed);
  }
  var animation = gsap.to(sprite, {
    pixi: { x: x, alpha: finalAlpha },
    duration: duration * speed,
    ease: 'slow(0.3, 0.7, false)',
    delay: delay,
    paused: true,
  });
  return animation;
}
export default { Animate };
